/**
 * @fileoverview Scene controller for entry.
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _tool = require("@entrylabs/tool");
/**
 * Class for a scene controller.
 * This have view for scenes.
 * @constructor
 */
var STATIC_SCENES_COUNT = 30;
Entry.Scene = /*#__PURE__*/function () {
  function _class() {
    (0, _classCallCheck2["default"])(this, _class);
    this.scenes_ = [];
    this.selectedScene = null;
    this.maxCount = this.getMaxSceneCount() || 30;
    $(window).on('resize', this.resize.bind(this));
    this.disposeEvent = Entry.disposeEvent.attach(this, function (e) {
      var elem = document.activeElement;
      if (e && elem && elem !== e.target && $(elem).hasClass('entrySceneFieldWorkspace')) {
        elem.blur();
      }
    });
  }

  /**
   * Control bar view generator.
   * @param {!Element} sceneView sceneView from Entry.
   * @param {?string} option for choose type of view.
   */
  return (0, _createClass2["default"])(_class, [{
    key: "generateView",
    value: function generateView(sceneView, option) {
      var _this = this;
      this.view_ = sceneView;
      this.view_.addClass('entryScene');
      if (!option || option === 'workspace' || option === 'playground') {
        this.view_.addClass('entrySceneWorkspace');
        $(this.view_).on('mousedown touchstart', function (e) {
          var offset = $(_this.view_).offset();
          var $window = $(window);
          var slope = -40 / 55;
          var selectedScene = _this.selectedScene;
          var selectedLeft = $(selectedScene.view).find('.entrySceneRemoveButtonCoverWorkspace').offset().left;
          var x = e.pageX - offset.left + $window.scrollLeft() - selectedLeft;
          var y = 40 - (e.pageY - offset.top + $window.scrollTop());
          if (x < selectedLeft || x > selectedLeft + 55) {
            return;
          }
        });
        var listView = this.createListView();
        this.view_.appendChild(listView);
        this.listView_ = listView;
        if (Entry.sceneEditable) {
          var addButton = this.createAddButton();
          this.view_.appendChild(addButton);
          this.addButton_ = addButton;
          var scenePrevButton = this.scenePrevButton();
          var sceneNextButton = this.sceneNextButton();
          this.view_.appendChild(scenePrevButton);
          this.view_.appendChild(sceneNextButton);
          this.scenePrevButton = scenePrevButton;
          this.sceneNextButton = sceneNextButton;
          this.prevButton_ = scenePrevButton;
          this.nextButton_ = sceneNextButton;
          this.sceneListWidth = Entry.scene.listView_.offsetWidth;
          this.updateView();
        }
      }
    }
  }, {
    key: "createAddButton",
    value: function createAddButton() {
      var addButton = Entry.createElement('span').addClass('entrySceneElementWorkspace entrySceneAddButtonWorkspace');
      addButton.bindOnClick(function (e) {
        if (Entry.engine.isState('run')) {
          return;
        }
        Entry["do"]('sceneAdd', Entry.generateHash());
      });
      return addButton;
    }
    /**
     * prev scene button
     */
  }, {
    key: "scenePrevButton",
    value: function scenePrevButton() {
      var _this2 = this;
      var prevButton = Entry.createElement('span').addClass('entrySceneElementWorkspace entryScenePrevButtonWorkspace');
      var prevBtn = document.createElement('span').addClass('prevBtn');
      prevButton.bindOnClick(function (e) {
        _this2.selectScene(Entry.scene.getPrevScene());
      });
      prevButton.appendChild(prevBtn);
      return prevButton;
    }
    /**
     * next scene, add scene button
     */
  }, {
    key: "sceneNextButton",
    value: function sceneNextButton() {
      var _this3 = this;
      var nextButton = Entry.createElement('span').addClass('entrySceneElementWorkspace entrySceneNextButtonWorkspace');
      var nextBtn = document.createElement('span').addClass('nextBtn');
      nextBtn.bindOnClick(function (e) {
        _this3.selectScene(Entry.scene.getNextScene());
      });
      var addButton = document.createElement('span').addClass('addButton');
      addButton.bindOnClick(function (e) {
        if (Entry.engine.isState('run')) {
          return;
        }
        _this3.sceneListwidth = Entry.scene.listView_.offsetWidth;
        Entry["do"]('sceneAdd', Entry.generateHash());
      });
      this.nextAddButton_ = addButton;
      nextButton.appendChild(nextBtn);
      nextButton.appendChild(addButton);
      return nextButton;
    }
  }, {
    key: "createListView",
    value: function createListView() {
      var _this4 = this;
      var listView = Entry.createElement('div');
      listView.addClass('entrySceneListWorkspace');
      var observer = new ResizeObserver(function () {
        _this4.updateView();
      });
      observer.observe(listView);
      this.sceneSortableListWidget = new _tool.Sortable({
        data: {
          height: '100%',
          sortableTarget: ['entrySceneRemoveButtonWorkspace', 'entrySceneInputCover'],
          lockAxis: 'x',
          axis: 'x',
          items: this._getSortableSceneList()
        },
        container: listView
      });
      if (Entry.sceneEditable) {
        this.sceneSortableListWidget.on('change', function (_ref) {
          var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            newIndex = _ref2[0],
            oldIndex = _ref2[1];
          Entry.scene.moveScene(newIndex, oldIndex);
        });
      }
      return listView;
    }
  }, {
    key: "updateSceneView",
    value: function updateSceneView() {
      var _this5 = this;
      var items = this._getSortableSceneList();
      if (this.sceneSortableListWidget) {
        setTimeout(function () {
          return _this5.sceneSortableListWidget.setData({
            items: items
          });
        }, 0);
      }
    }
  }, {
    key: "_getSortableSceneList",
    value: function _getSortableSceneList() {
      if (!this.scenes_ || this.scenes_.length === 0) {
        return [];
      }
      return this.scenes_.map(function (value) {
        return {
          key: value.id,
          item: value.view
        };
      });
    }

    /**
     * generate li element for scene
     * @param {!scene model} scene
     */
  }, {
    key: "generateElement",
    value: function generateElement(scene) {
      var _this6 = this;
      var viewTemplate = this.createViewTemplate(scene);
      Entry.Utils.disableContextmenu(viewTemplate);
      var nameField = this.createNameField(scene);
      viewTemplate.nameField = nameField;
      var sceneLeft = this.createSceneLeft();
      viewTemplate.appendChild(sceneLeft);
      var divide = this.createSceneDivider();
      viewTemplate.appendChild(divide);
      scene.inputWrapper = divide;
      divide.appendChild(nameField);
      var removeButtonCover = this.createRemoveButtonCover();
      viewTemplate.appendChild(removeButtonCover);
      if (Entry.sceneEditable) {
        scene.removeButton = this.createRemoveButton(scene, removeButtonCover);
        Entry.ContextMenu.onContextmenu(viewTemplate, function (coordinate) {
          var options = [{
            text: Lang.Workspace.duplicate_scene,
            enable: Entry.engine.isState('stop') && !_this6.isMax(),
            callback: function callback() {
              Entry.scene.cloneScene(scene);
            }
          }];
          Entry.ContextMenu.show(options, 'workspace-contextmenu', coordinate);
        });
      }
      scene.view = viewTemplate;
      return viewTemplate;
    }
  }, {
    key: "createRemoveButton",
    value: function createRemoveButton(scene, removeButtonCover) {
      return Entry.createElement('button').addClass('entrySceneRemoveButtonWorkspace').bindOnClick(function (e) {
        if (Entry.engine.isState('run')) {
          return;
        }
        var isDeletable = Entry.scene.getScenes().length > 1;
        if (!isDeletable) {
          Entry.toast.alert(Lang.Msgs.runtime_error, Lang.Workspace.Scene_delete_error, false);
          return;
        }
        Entry["do"]('sceneRemove', scene.id);
      }).appendTo(removeButtonCover);
    }
  }, {
    key: "createRemoveButtonCover",
    value: function createRemoveButtonCover() {
      var removeButtonCover = Entry.createElement('span');
      removeButtonCover.addClass('entrySceneRemoveButtonCoverWorkspace');
      return removeButtonCover;
    }
  }, {
    key: "createSceneDivider",
    value: function createSceneDivider() {
      var divide = Entry.createElement('span');
      divide.addClass('entrySceneInputCover');
      if (!Entry.sceneEditable) {
        divide.addClass('entryDisabledScene');
      }
      return divide;
    }
  }, {
    key: "createSceneLeft",
    value: function createSceneLeft() {
      var sceneLeft = Entry.createElement('span');
      sceneLeft.addClass('entrySceneLeftWorkspace');
      return sceneLeft;
    }
  }, {
    key: "createNameField",
    value: function createNameField(scene) {
      var nameField = Entry.createElement('input');
      nameField.addClass('entrySceneFieldWorkspace');
      nameField.value = scene.name;
      nameField.addEventListener('keyup', function (_ref3) {
        var code = _ref3.keyCode;
        if (Entry.isArrowOrBackspace(code)) {
          return;
        }
        var applyValue = function applyValue(value) {
          value !== scene.name && Entry["do"]('sceneRename', scene.id, value);
          nameField.blur();
        };
        var value = nameField.value;
        if (code === 13) {
          applyValue(value);
        } else if (value.length > 10) {
          value = value.substring(0, 10);
          applyValue(value);
        }
      });
      nameField.addEventListener('blur', function (e) {
        if (nameField.value !== scene.name) {
          Entry["do"]('sceneRename', scene.id, nameField.value);
        }
        var _Entry = Entry,
          _Entry$playground = _Entry.playground,
          playground = _Entry$playground === void 0 ? {} : _Entry$playground;
        var mainWorkspace = playground.mainWorkspace;
        if (mainWorkspace) {
          mainWorkspace.reDraw();
        }
      });
      if (!Entry.sceneEditable) {
        nameField.disabled = 'disabled';
      }
      return nameField;
    }
  }, {
    key: "createViewTemplate",
    value: function createViewTemplate(scene) {
      var viewTemplate = Entry.createElement('div', scene.id);
      viewTemplate.addClass('entrySceneElementWorkspace  entrySceneButtonWorkspace minValue');
      $(viewTemplate).on('mousedown touchstart', function (e) {
        if (Entry.engine.isState('run')) {
          return;
        }
        if (Entry.scene.selectedScene !== scene) {
          Entry["do"]('sceneSelect', scene.id);
          if (e.type === 'touchstart') {
            e.preventDefault();
          }
        }
      });
      return viewTemplate;
    }
  }, {
    key: "updateView",
    value: function updateView() {
      if (!Entry.type || Entry.type === 'workspace') {
        var addBtnWidth = 72;
        var sceneListWidth = this.sceneListWidth + addBtnWidth + 170;
        var browserWidth = Entry.view_.offsetWidth;
        var maxSceneCount = Entry.scene.scenes_.length || STATIC_SCENES_COUNT;
        if (this.addButton_) {
          if (maxSceneCount >= STATIC_SCENES_COUNT) {
            this.addButton_.addClass('entryRemove');
            this.nextAddButton_.addClass('entryRemove');
          } else {
            this.addButton_.removeClass('entryRemove');
            this.prevButton_.removeClass('entryRemove');
            this.nextButton_.removeClass('entryRemove');
            if (sceneListWidth > browserWidth) {
              this.addButton_.addClass('entryRemove');
              this.nextAddButton_.removeClass('entryRemove');
            } else {
              this.nextButton_.addClass('entryRemove');
              this.prevButton_.addClass('entryRemove');
            }
          }
        }
      }
      this.updateSceneView();
      this.resize();
    }

    /**
     * add scenes
     * @param {Array<scene model>} scenes
     */
  }, {
    key: "addScenes",
    value: function addScenes(scenes) {
      this.scenes_ = scenes;
      if (!scenes || scenes.length === 0) {
        this.scenes_ = [];
        this.scenes_.push(this.createScene());
      } else {
        for (var i = 0, len = scenes.length; i < len; i++) {
          this.generateElement(scenes[i]);
        }
      }
      this.selectScene(this.getScenes()[0]);
    }
    /**
     * add scenes to this.scenes_
     * @param {scene model} scene
     */
  }, {
    key: "addScene",
    value: function addScene(scene, index) {
      if (scene === undefined || typeof scene === 'string') {
        scene = this.createScene(scene);
      }
      if (!scene.view) {
        this.generateElement(scene);
      }
      if (!index && typeof index != 'number') {
        this.getScenes().push(scene);
      } else {
        this.getScenes().splice(index, 0, scene);
      }
      Entry.stage.objectContainers.push(Entry.stage.createObjectContainer(scene));
      this.selectScene(scene);
      if (Entry.creationChangedEvent) {
        Entry.creationChangedEvent.notify();
      }
      var _ref4 = Entry || {},
        _ref4$playground = _ref4.playground,
        playground = _ref4$playground === void 0 ? {} : _ref4$playground;
      var mainWorkspace = playground.mainWorkspace;
      if (mainWorkspace) {
        mainWorkspace.reDraw();
      }
      return scene;
    }

    /**
     * remove scene from this.scenes_
     * @param {!scene model} scene
     */
  }, {
    key: "removeScene",
    value: function removeScene(scene) {
      if (this.getScenes().length <= 1) {
        Entry.toast.alert(Lang.Msgs.runtime_error, Lang.Workspace.Scene_delete_error, false);
        return;
      }
      Entry.Utils.forceStopSounds();
      scene = this.getSceneById(typeof scene === 'string' ? scene : scene.id);
      this.getScenes().splice(this.getScenes().indexOf(scene), 1);
      Entry.container.getSceneObjects(scene).forEach(function (object) {
        return Entry.container.removeObject(object, true);
      });
      Entry.stage.removeObjectContainer(scene);
      $(scene.view).remove();
      this.selectScene();
      if (Entry.codeChangedEvent) {
        Entry.codeChangedEvent.notify();
      }
    }
  }, {
    key: "selectScene",
    value: function selectScene(scene) {
      var targetScene = scene || this.getScenes()[0];
      var container = Entry.container;
      container.resetSceneDuringRun();
      if (this.selectedScene && this.selectedScene.id === targetScene.id) {
        return;
      }
      if (Entry.playground.getViewMode() === 'picture' && Entry.playground.nameViewFocus && Entry.playground.nameViewBlur()) {
        return;
      }
      var prevSelected = this.selectedScene;
      if (prevSelected) {
        var prevSelectedView = prevSelected.view;
        prevSelectedView.removeClass('selectedScene');
        var elem = document.activeElement;
        elem === prevSelectedView.nameField && elem.blur();
      }
      this.selectedScene = targetScene;
      targetScene.view.addClass('selectedScene');
      var stage = Entry.stage;
      var playground = Entry.playground;
      container.setCurrentObjects();
      stage.selectObjectContainer(targetScene);
      var targetObject = container.getCurrentObjects()[0];
      if (Entry.engine.isState('run')) {
        Entry.Utils.forceStopSounds();
      }
      if (targetObject && Entry.type !== 'minimize') {
        container.selectObject(targetObject.id);
        playground.refreshPlayground();
      } else {
        if (Entry.isTextMode) {
          var workspace = Entry.getMainWS();
          var vimBoard = workspace && workspace.vimBoard;
          if (vimBoard) {
            var sObject = vimBoard._currentObject;
            var sScene = vimBoard._currentScene;
            var parser = vimBoard._parser;
            try {
              if (targetScene.id != sScene.id) {
                workspace._syncTextCode();
              }
            } catch (e) {}
            if (parser._onError) {
              container.selectObject(sObject.id, true);
              return;
            }
          }
          vimBoard && vimBoard.clearText();
        }
        stage.selectObject(null);
        playground.flushPlayground();
        Entry.variableContainer.selected = null;
        Entry.variableContainer.updateList();
      }
      !container.listView_ && stage.sortZorder();
      container.updateListView();
      if (Entry.type && Entry.type !== 'minimize' && Entry.scene.listView_) {
        this.sceneListWidth = Entry.scene.listView_.offsetWidth;
      }
      this.updateView();
      Entry.requestUpdate = true;
    }

    /**
     * convert this scenes data to JSON.
     * @return {JSON}
     */
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.getScenes().map(function (scene) {
        return _.pick(scene, ['id', 'name']);
      });
    }

    /**
     * Move scene in this.scenes_
     * this method is for sortable
     * @param {!number} start
     * @param {!number} end
     */
  }, {
    key: "moveScene",
    value: function moveScene(start, end) {
      this.getScenes().splice(end, 0, this.getScenes().splice(start, 1)[0]);
      Entry.container.updateObjectsOrder();
      Entry.stage.sortZorder();
      this.updateSceneView();
      //style properties are not removed sometimes
      $('.entrySceneElementWorkspace').removeAttr('style');
    }

    /**
     * get scene by scene id
     * @param {!String} sceneId
     * @return {scene modal}
     */
  }, {
    key: "getSceneById",
    value: function getSceneById(id) {
      return _.find(this.getScenes(), {
        id: id
      }) || false;
    }

    /**
     * @return {Array<Entry scene>}
     */
  }, {
    key: "getScenes",
    value: function getScenes() {
      return this.scenes_;
    }

    /**
     * remember selectedScene before start
     * in order to reset when stopped
     */
  }, {
    key: "takeStartSceneSnapshot",
    value: function takeStartSceneSnapshot() {
      this.sceneBeforeRun = this.selectedScene;
    }

    /**
     * select selectedScene before start
     * before run start
     */
  }, {
    key: "loadStartSceneSnapshot",
    value: function loadStartSceneSnapshot() {
      this.selectScene(this.sceneBeforeRun);
      this.sceneBeforeRun = null;
    }
    /**
     * create scene
     * @return {scene modal} scene
     */
  }, {
    key: "createScene",
    value: function createScene(sceneId) {
      var regex = /[0-9]/;
      var name = Entry.getOrderedName("".concat(Lang.Blocks.SCENE, " "), this.scenes_, 'name');
      if (!regex.test(name)) {
        name += '1';
      }
      var scene = {
        name: name,
        id: sceneId || Entry.generateHash()
      };
      this.generateElement(scene);
      return scene;
    }

    /**
     * clone scene by context menu
     * @param {!scene model} scene
     */
  }, {
    key: "cloneScene",
    value: function cloneScene(scene) {
      if (this.isMax()) {
        Entry.toast.alert(Lang.Msgs.runtime_error, Lang.Workspace.Scene_add_error, false);
        return;
      }
      var clonedScene = {
        name: (Lang.Workspace.cloned_scene + scene.name).substring(0, 10),
        id: Entry.generateHash()
      };
      this.generateElement(clonedScene);
      this.addScene(clonedScene);
      var container = Entry.container;
      var objects = container.getSceneObjects(scene);
      try {
        var oldIds = [];
        var newIds = [];
        this.isSceneCloning = true;
        for (var i = objects.length - 1; i >= 0; i--) {
          var obj = objects[i];
          var ret = container.addCloneObject(obj, clonedScene.id, true);
          oldIds.push(obj.id);
          newIds.push(ret.id);
        }
        container.adjustClonedValues(oldIds, newIds);
        var WS = Entry.getMainWS();
        WS && WS.board && WS.board.reDraw();
        this.isSceneCloning = false;
        container.setCurrentObjects();
        container.updateObjectsOrder();
        container.updateListView();
        container.selectObject(newIds[newIds.length - 1]);
        Entry.variableContainer.updateViews();
      } catch (e) {
        console.log('error', e);
      }
    }

    /**
     * resize html element by window size
     * @param {!scene model} scene
     */
  }, {
    key: "resize",
    value: function resize() {
      var scenes = this.getScenes();
      var selectedScene = this.selectedScene;
      var addButton = this.addButton_;
      var firstScene = scenes[0];
      if (scenes.length === 0 || !firstScene) {
        return;
      }
      var startPos = $(firstScene.view).offset().left;
      var marginLeft = parseFloat($(selectedScene.view).css('margin-left'));
      var totalWidth = Math.floor($(this.view_).width() - startPos - 5);
      var LEFT_MARGIN = -40;
      var normWidth = startPos + 15;
      var diff = 0;
      var isSelectedView = false;
      var selectedViewWidth = 0;
      for (var i in scenes) {
        var scene = scenes[i];
        var view = scene.view;
        view.addClass('minValue');
        isSelectedView = view === this.selectedScene.view;
        view = $(view);
        var width = parseFloat(Entry.computeInputWidth(scene.name));
        var adjusted = width * 10 / 9;
        if (scene === this.selectedScene) {
          diff = adjusted - width;
        }
        // $(scene.inputWrapper).width(adjusted + 'px');
        var viewWidth = view.width();
        if (isSelectedView) {
          selectedViewWidth = viewWidth;
        }
        normWidth += viewWidth + LEFT_MARGIN;
      }
      if (normWidth > totalWidth) {
        align();
      }
      function align() {
        var dummyWidth = 30.5;
        var len = scenes.length - 1;
        totalWidth = totalWidth - Math.round(selectedViewWidth || $(selectedScene.view).width()) - dummyWidth * len - diff;
        var fieldWidth = Math.floor(totalWidth / len);
        for (i in scenes) {
          scene = scenes[i];
          if (selectedScene.id != scene.id) {
            scene.view.removeClass('minValue');
            // $(scene.inputWrapper).width(fieldWidth);
          } else {
            scene.view.addClass('minValue');
          }
        }
      }
    }
  }, {
    key: "getPrevScene",
    value: function getPrevScene() {
      var scenes = this.getScenes();
      return scenes[scenes.indexOf(this.selectedScene) - 1];
    }
  }, {
    key: "getNextScene",
    value: function getNextScene() {
      var scenes = this.getScenes();
      return scenes[scenes.indexOf(this.selectedScene) + 1];
    }
  }, {
    key: "getMaxSceneCount",
    value: function getMaxSceneCount() {
      return STATIC_SCENES_COUNT;
    }
  }, {
    key: "isMax",
    value: function isMax() {
      return Entry.scene.scenes_.length >= STATIC_SCENES_COUNT;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.scenes_.forEach(function (s) {
        return Entry.stage.removeObjectContainer(s);
      });
      this.scenes_ = [];
      this.selectedScene = null;
      this.updateView();
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      var scene;
      if (query.length > 1) {
        scene = this.getSceneById(query[1]);
      }
      switch (query[0]) {
        case 'addButton':
          return this.addButton_;
        case 'removeButton':
          return scene.removeButton;
        case 'nameField':
          return scene.view.nameField;
        case 'view':
          return scene.view;
        default:
          return;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // 우선 interface 만 정의함.
    }
  }]);
}();